/** Klassennamen zusammensetzen, leere Werte fallen weg. */
export function cx(...teile) {
    return teile.filter(Boolean).join(' ');
}
